import { render } from "./Ontology.vue?vue&type=template&id=5e156fe7&scoped=true"
import script from "./Ontology.vue?vue&type=script&lang=js"
export * from "./Ontology.vue?vue&type=script&lang=js"

import "./Ontology.vue?vue&type=style&index=0&id=5e156fe7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e156fe7"]])

export default __exports__